<template>
  <div id="app">
    <TopNav />
    <!-- <Scenes ref="scenesRef" /> -->
    <Tool />
    <EyedropperBox />
    <!-- <RightNav /> -->

    <!-- <MaterialPane /> -->
    <MaterialArea></MaterialArea>

    <SettingPanel />
    <presentationLayer></presentationLayer>
    <CropLayer />
    <CropSvgLayer />
    <CutFrame />
    <TakePoints />
    <TransparentMask />
    <freePathEdit />
    <WordCloud />
    <TemplateMaterialLibrary />
    <!-- <AnimCourse></AnimCourse> -->
    <Popups />
    <Popups-z />
    <Sound />
    <Keyboard />
    <!-- <FloatingMenu /> -->
    <Modal />
    <EModals />
    <EModals2 />
    <Upload />
    <Undo />
    <Draw />
    <!-- <Guidance /> -->
    <Tip v-if="!openSubtitle" />
    <NewVersion :allFormJson="allFormJson" />
    <PayPanel :template="currentTemplate" v-model="payvisible" />
    <!-- <SoundGuide></SoundGuide> -->
    <SubtitleMessageDialog></SubtitleMessageDialog>
    <UserTask v-if="'leave' !== $store.getters['userTask/viewType']"></UserTask>
    <UserTaskQuitting />
    <UserTaskFinishing />
    <invitationNotice></invitationNotice>
  </div>
</template>

<script>
import flatten from "lodash/flatten";
import AnimEditor from "../static/animengine/js/neweditor.js";

import se_move from "../static/animengine/js/scene-effects/se-move.js";
import se_basic from "../static/animengine/js/scene-effects/se-basic.js";
import se_lottie from "../static/animengine/js/scene-effects/se-lottie.js";
import se_tv_noise from "../static/animengine/js/scene-effects/se-tv-noise.js";
import se_slice from "../static/animengine/js/scene-effects/se-slice.js";
import se_swipe from "../static/animengine/js/scene-effects/se-swipe.js";
import se_camera from "../static/animengine/js/scene-effects/se-camera.js";
import se_spiralz_svg from "../static/animengine/js/scene-effects/se-spiralz-svg.js";
import se_flip_book from "../static/animengine/js/scene-effects/se-flip-book.js";
import se_row_spread from "../static/animengine/js/scene-effects/se-row-spread.js";
import se_mosaic from "../static/animengine/js/scene-effects/se-mosaic.js";

import s_smear from "../static/animengine/js/sprite-effects/smear.js";
import s_type from "../static/animengine/js/sprite-effects/type.js";
import s_roll from "../static/animengine/js/sprite-effects/roll.js";
import s_hand from "../static/animengine/js/sprite-effects/hand.js";
import s_bounce from "../static/animengine/js/sprite-effects/bounce.js";

import calc_offset from "../static/animengine/js/path-effects/calcOffset.js";
import art_effect from "../static/animengine/js/art-effects/artEffect.js";
import art_style from "../static/animengine/js/art-effects/artStyle.js";

import SoundPlayHandle from "../static/animengine/js/soundPlay.js";

// 挂载场景特效、元素特效及其他特效扩展
se_move(AnimEditor);
se_basic(AnimEditor);
se_lottie(AnimEditor);
se_tv_noise(AnimEditor);
se_slice(AnimEditor);
se_swipe(AnimEditor);
se_camera(AnimEditor);
se_spiralz_svg(AnimEditor);
se_flip_book(AnimEditor);
se_row_spread(AnimEditor);
se_mosaic(AnimEditor);

s_smear(AnimEditor);
s_type(AnimEditor);
s_roll(AnimEditor);
s_hand(AnimEditor);
s_bounce(AnimEditor);

art_style(AnimEditor);
art_effect(AnimEditor);
calc_offset(AnimEditor);

AnimEditor.soundPlayHandle = new SoundPlayHandle();

import "es6-promise/auto";
import { mapGetters, mapActions } from "vuex";

import TopNav from "./components/TopNav.vue"; // 顶层导航
import Scenes from "./components/Scenes.vue"; // 左侧scenes
import Tool from "./components/Tool.vue"; // 编辑器
import EyedropperBox from "./components/EyedropperBox.vue"; // EyedropperBox 10
import RightNav from "./components/RightNav.vue"; // 右侧导航
// import MaterialPane from "./components/MaterialPane.vue"; // 素材面板
import MaterialArea from "./components/MaterialArea.vue"; // 新素材面板
import SettingPanel from "./components/settingPanel.vue"; // 右侧设置栏
import Popups from "./components/Popups.vue"; // 全局弹窗组件                 40
import Sound from "./components/Sound.vue"; // 全局声音组件
import Keyboard from "./components/Keyboard.vue"; // 全局快捷键组件
import Modal from "./components/Modal.vue"; // 全局拟态窗组件                30
import EModals from "./components/EModals.vue"; // 包含element dialog的容器     30
import EModals2 from "./components/EModals2.vue"; // 包含element dialog的容器     30
import Upload from "./components/Upload.vue"; // 上传组件
import Draw from "./components/Draw.vue"; // 上传组件
import Guidance from "./components/Guidance.vue"; // 新手引导
import NewVersion from "./components/NewVersion.vue"; // 新手引导
import Tip from "./components/guidance/tip.vue"; // 新手引导
import PopupsZ from "./components/Popups-z";
import CropLayer from "./components/CropLayer";
import CropSvgLayer from "./components/CropSvgLayer";
import CutFrame from "./components/CutFrame";
import TakePoints from "./components/TakePoints";
import TransparentMask from "./components/TransparentMask";
import PayPanel from "./components/PayPanel";
import freePathEdit from "./components/freePathEdit"; // 自由路径绘制
import WordCloud from "./components/WordCloud";
import TemplateMaterialLibrary from "./components/TemplateMaterialLibrary"; //模板素材库

import Undo from "./undo/undo.vue"; // 撤销和恢复
import textArtData from "./components/mixins/textArtData.vue"; // 艺术字体数据
import checkPersonVideo from "./components/mixins/checkPersonVideo";
// import FloatingMenu from "./components/FloatingMenu";
import AnimCourse from "./components/AnimCourse";
import SubtitleMessageDialog from "./components/SubtitleMessageDialog";
import UserTask from './components/userTask/userTaskLayer';
import UserTaskQuitting from './components/userTask/quittingModal';
import UserTaskFinishing from './components/userTask/finishingModal';
import presentationLayer from './components/draftPreview/presentationLayer.vue';
import invitationNotice from './components/invitationNotice/index.vue'

const uniqueElementsBy = (arr, fn) =>
  arr.reduce((acc, v) => {
    if (!acc.some((x) => fn(v, x))) acc.push(v);
    return acc;
  }, []);

export default {
  name: "App",
  mixins: [textArtData, checkPersonVideo],
  data() {
    return {
      EDITOR: {},
      spritesMsg: false,
      allFormJson: false, // 全局fromjson
      windowPace: {
        eve: 0,
        ele: "",
      },
      SwitchStyleTip: 0, // 切换导航 提醒
      scenesUndoRudo: false,
      currentTemplate: {}, // 模版数据
      // payvisible: false, // 显示vip弹窗的隐藏
      isFirstQuestSession: true,
      isFirstAddSprite: true,
      willCheckMaterial: false,
      willCheckSound: true,
      userIdMap: {},
    };
  },
  computed: {
    ...mapGetters([
      "Window_Size",
      "Tool_Size",
      "MaterialPane_Size",
      "TopNav_Size",
      "SelectScenes_Msg",
      "TOOL",
      "StyleMsg",
      "SpriteOperation",
      "SelectSprites_Msg",
      "UserEquity",
      "UserLevel",
      "UserLevelName",
      "UserLevelType",
      'UserLevelInfo',
      'IsEnjoymentLevel',
      "IsVipSprites",
      "PersonVideoNumber",
      "UserMsg",
      "FreeVideoIds",
      "LoadType",
      "downFonts",
      "isPersonVip",
      "cooperationDraftOwnerId",
      "WorksId",
      "ShowLibUseTemplateLoading",
      "isPoor",
      "isTmpSolo",
      "templatePayingVisible",
      "WorksName",
      "CommercialRisk",
      "DelStamp",
      'IsOldUser',
      'IsProLevelSystem'
    ]),
    ...mapGetters({
      openSubtitle: "subtitle/openSubtitle",
      musicArr: "addSoundtrack/getMusicArr",
      dubbingArr: "addSoundtrack/getDubbingArr",
      smartVoices: "smartVoice/worksList",
      trackingData: "tracking/trackingData",
      resourceTypeToText: "resources/resourceTypeToText",
    }),
    payvisible: {
      get() {
        return this.templatePayingVisible;
      },
      set(val) {
        this.$store.commit("setTemplatePayingVisible", val);
      },
    },
  },
  watch: {
    smartVoices: {
      handler(val) {
        this.handleDubbingText(val);
      },
    },
    // openSubtitle (val) {
    //   val && this.handleDubbingText(this.smartVoices);
    // },
    musicArr: {
      deep: true,
      handler(val, oldVal) {
        const isEmpty = val && !val.length;
        this.$bus.emit("tellTopNavSaveState");
        let isSwap = this.checkSoundSwap(val);
        if (isEmpty || (isSwap && this.willCheckSound)) {
          this.checkSoundsMaterial(val, "2");
          this.requestCheckCommercial();
        }
      },
    },
    dubbingArr: {
      deep: true,
      handler(val) {
        this.$bus.emit("tellTopNavSaveState");
        let isSwap = this.checkSoundSwap(val);
        if (isSwap && this.willCheckSound) {
          this.checkSoundsMaterial(val, "1");
          this.requestCheckCommercial();
        }
      },
    },
    "musicArr.length"(val, oldVal) {
      console.log(`Turbo ~ val:`, val)
      this.$bus.emit("tellTopNavSaveState");
      if (val != oldVal && this.willCheckSound) {
        this.checkSoundsMaterial(this.musicArr, "2");
        this.requestCheckCommercial();
      }
    },
    "dubbingArr.length"(val, oldVal) {
      this.$bus.emit("tellTopNavSaveState");
      if (val != oldVal && this.willCheckSound) {
        this.checkSoundsMaterial(this.dubbingArr, "1");
        this.requestCheckCommercial();
      }
    },
    StyleMsg: function () {
      // 弹出风格选择框
      this.judgeStyle(); // 判断style风格是否存在
    },
    SelectSprites_Msg: function (val, oldval) {
      // 监听选中元素
      if (
        this.SelectSprites_Msg.length &&
        this.SelectSprites_Msg.length === 1
      ) {
        this.selectedVipFlag = true;
        // 判断是否为vip
        // 判断素材收费种类
        this.judgeItemPayType(void 0, { willCheckCommercial: true });
      }
    },
    SelectScenes_Msg: function (val, oldval) {
      console.log(`Turbo ~ val:`, val)
      // 加载分组音乐
      if (this.allFormJson) {
        let dataScenes = this.SelectScenes_Msg.toJson();
        if (dataScenes && dataScenes.resourceId && this.scenesUndoRudo) {
          this.scenesUndoRudo = false;
          let judgeData = {
            type: "scenes",
            id: dataScenes.resourceId,
            option: {
              resourceId: dataScenes.resourceId, // 背景资源id
              fileType: 24, // 背景资源type
            },
            opHelper: {
              isSvip: false,
            },
            scenesId: dataScenes.id,
          };
          this.judgeItemPayType(judgeData);
        }

        let dataBG = dataScenes.background;
        if (dataBG && dataBG.resourceId) {
          let judgeVip = this.judgeSoundBgIsVip(
            "BG-" + this.SelectScenes_Msg.id
          );
          if (judgeVip) {
            let judgeDataBG = {
              type: "bg",
              id: "BG-" + this.SelectScenes_Msg.id,
              option: {
                resourceId: dataBG.resourceId, // 背景资源id
                fileType: dataBG.fileType, // 背景资源type
              },
              opHelper: {
                isSvip: false,
              },
              scenesId: this.SelectScenes_Msg.id,
            };
            this.judgeItemPayType(judgeDataBG, { willCheckCommercial: false });
          }
        }
      }
    },
    "SelectScenes_Msg.soundRecord"() {
      this.onSceneSoundUpdate();
    },
    "SelectScenes_Msg.sound"() {
      this.onSceneSoundUpdate();
    },
    "TOOL.soundRecord": function (val, oldval) {
      if (this.allFormJson) {
        if (this.TOOL.soundRecord && !this.UserEquity.uploadSound) {
          // 添加全局录音进入VIP
          this.$store.commit("push_vipSprites", {
            id: "AllSound",
            type: "AllSound",
            scenesId: "AllSound",
            resourceId: this.TOOL.soundRecord.resourceId,
          });

          let isCoworker = this.isCoworker();
          !isCoworker &&
            this.$message({
              showClose: true,
              message:
                "您正在使用VIP功能或资源，若您需要导出视频，还请升级会员。",
              type: "error",
            });
        } else {
          this.$store.commit("del_vipSprites", { id: "AllSound" });
        }
        this.requestCheckCommercial();
      }
    },
    "TOOL.sound": function (val, oldval) {
      if (this.allFormJson) {
        if (this.TOOL.soundRecord && !this.UserEquity.uploadSound) {
          // 添加全局录音进入VIP
          this.$store.commit("push_vipSprites", {
            id: "TOOLsound",
            type: "TOOLsound",
            scenesId: "TOOLsound",
            resourceId: this.TOOL.sound.resourceId,
          });

          let isCoworker = this.isCoworker();
          !isCoworker &&
            this.$message({
              showClose: true,
              message:
                "您正在使用VIP功能或资源，若您需要导出视频，还请升级会员。",
              type: "error",
            });
        } else {
          this.$store.commit("del_vipSprites", { id: "TOOLsound" });
        }
        this.requestCheckCommercial();
      }
    },
    "TOOL.loading": {
      handler(val, oldval) {
        if (
          this.TOOL.loading.status === "success" &&
          this.TOOL.loading.allVideosReady
        ) {
          this.windowPace.eve = 1;
          if (this.windowPace.ele) {
            this.windowPace.ele.style.display = "none";
            this.allFormJson = true;
          }
        }
      },
      deep: true,
    },
    allFormJson: function (val, oldval) {},
    "SelectScenes_Msg.background.data.data.url": function (val, oldval) {
      // 判断背景改变
      if (this.allFormJson && this.willCheckMaterial) {
        this.judgeToolVideo(true);
      }
    },
    LoadType(val) {
      if (val === "blank") {
        this.getCheckFont();
      }
    },
    // ShowLibUseTemplateLoading (val, oldVal) {
    //   if (oldVal || val) {
    //     this.scenesAllSprites(true);
    //   }
    // },
    CommercialRisk(val) {},
    DelStamp(val) {
      this.requestCheckCommercial();
    },
  },
  created() {
    // console.log('creating');
    if (this.$route.subtitle) return;

    // this.TOOL.eve.on("sceneSprite.unLoadData.fromJsonLoadingState", (data) => {
    //   if (data && data.state == 2) {
    //     this.scenesAllSprites(true);
    //   }
    // });

    this.$bus.on("loadingAllScenes", (state) => {
      if (state === "start") {
        this.willCheckMaterial = false;
      } else {
        this.willCheckMaterial = true;
        this.willCheckSound = true;
        this.scenesAllSprites(true);
      }
    });

    // 模板加载素材检查，特殊对待，不通过allFormJson监听
    this.$bus.on("saveDraftOnTplGot", async () => {
      this.willCheckMaterial = true;
      if (this.LoadType === "template") {
        await this.scenesAllSprites(true);
        // this.checkJson(this.TOOL.toJson());
      }
      await this.checkSoundsMaterial(this.musicArr, "2");
      this.willCheckSound = true;
    });

    this.$bus.on("updateAllScenes", async () => {
      this.handleDubbingText(this.smartVoices);
      this.willCheckMaterial = true;
      if (this.LoadType !== "template") {
        await this.scenesAllSprites(true);
        // this.checkJson(this.TOOL.toJson());
      }
      await this.checkSoundsMaterial(this.dubbingArr, "1");
      this.willCheckSound = true;
      let scene = this.TOOL.sprites;
      console.log(`Turbo ~ this.$bus.on ~ scene:`, scene);
      let IPRoleLists = [];
      for (let i = 0; i < scene.length; i++) {
        const IPRoleList = scene[i].sprites.filter((item) => item.option.fileType === 10);
        console.log(`Turbo ~ this.$bus.on ~ IPRoleList:`, IPRoleList);
        IPRoleList.forEach((item) => {
          IPRoleLists.push({
            id: item.option.resourceId,
            fileType: item.option.fileType,
            uuid: item.id,
            sceneId: item.option.scenesId
          });
          console.log(`Turbo ~ IPRoleList.forEach ~ IPRoleLists:`, IPRoleLists);
        })
      }
      console.log(`Turbo ~ IPRoleList.forEach ~ IPRoleLists:`, IPRoleLists);
      const resp = await this.$http.post('/api/user/material/checkMaterial', {
        dataList: JSON.stringify(IPRoleLists),
        draftId: this.WorksId
      })
      console.log(`Turbo ~ this.$bus.on ~ resp:`, resp);
      if (resp.data.code !== 200) {
        return;
      }

      // 获取所有付费IP的动作
      const filterIPRole = [];
      for (const item of resp.data.data.ipPayList) {
        const res = await this.$http.get('/api/common/character/actionsAndCharacter', {
          params: {
            id: item.id
          }
        })
        filterIPRole.push(res.data.data);
      }
      console.log(`Turbo ~ this.$bus.on ~ filterIPRole:`, filterIPRole);

      // 过滤同个IP中的不同动作
      const filteredIPRole = () => {
        const map = new Map();
        for (let i = 0; i < filterIPRole.length; i++) {
          if (!map.has(filterIPRole[i].uid)) {
            map.set(filterIPRole[i].uid, filterIPRole[i]);
          }
        }
        return [...map.values()];
      }
      const filteredIPRoleList = filteredIPRole();
      console.log(`Turbo ~ this.$bus.on ~ filteredIPRoleList:`, filteredIPRoleList);

      // 获取所有IP数据
      let ipPayList = [];
      if (resp.data.code === 200) {
        ipPayList = resp.data.data.ipPayList;
        console.log(`Turbo ~ this.$bus.on ~ ipPayList:`, ipPayList);
        if (ipPayList.length !== 0) {
          this.$modal.show('IPRolePayTip', {
            ipPayList: ipPayList,
            filteredIPRoleList: filteredIPRoleList
          })
        }
      }
    });

    this.$bus.on("checkMaterial.music", (mArr) => {
      this.checkSoundsMaterial(mArr, "2");
      this.requestCheckCommercial();
    });

    // this.$bus.on('font', (font, fromWhere) => {
    //   // this.judgeItemPayType();
    // });

    eve.on("changeTextOption", (textSprite) => {
      this.$store.commit("del_vipSprites", textSprite);
      this.judgeItemPayType(textSprite);
    });
    eve.on("toFromJsonDone", () => {
      this.scenesAllSprites();
      this.requestCheckCommercial();
    });
    eve.on("onResourcesFetched", (data) => {
      const params = data.params;
      if (!params.keyword) {
        return;
      }
      const resp = data.response.data;
      sensors.track("searchResult", {
        search_source: "编辑器素材栏",
        keyword: params.keyword,
        has_result: resp.total > 0 || false,
        material_type: this.resourceTypeToText[params.type] || "素材",
        search_type: params.type === "template" ? "模板" : "素材搜索",
        search_result_num: resp.total,
        keyword_type: this.trackingData.keyword_type || "手动输入",
      });
      this.$store.commit("tracking/setTrackingData", {
        keyword_type: "",
      });
    });

    this.ifShowUserTask();
  },
  mounted() {
    const m = this.$message({
      message: 1,
      type: "success",
    });
    m.close();

    // 默认展示功能
    this.$memberGuide({
      show: false,
    });
    // this.testMine();
    // this.testApi();
    // 测试cookie
    // document.cookie =
    // "EGG_SESS=iXlkIr6ehdZG88hcyA7u6hRf3gcoPv3SZ_5nbshg_9QticX9kkZ1iyGVMgWYzytq";
    eve.on("windowLoadingDom", (data) => {
      if (data.type && this.TOOL.loading.status === "success") {
      }
      this.windowPace.ele = data.el;
      if (this.windowPace.eve === 1) {
        this.windowPace.ele.style.display = "none";
        this.allFormJson = true;
      }
    });
    // 获取用户数据
    this.upDataUserMsg();
    this.$bus.on("upDataUserMsg_vue", (data) => {
      // formjson所有信息
      this.upDataUserMsg();
    });

    this.windowSize();
    window.onresize = (e) => {
      // 全局尺寸改变
      // 关闭选色层
      if (e.target.innerWidth < 1200) {
        $("html").scrollLeft(1200 - e.target.innerWidth);
      }
      this.$bus.emit("eyedropperBox.hide");

      return (() => {
        this.windowSize();
      })();
    };
    let html = $("html");
    if (html.width() < 1200) html.scrollLeft(1200 - html.width());
    html = null;

    // 退出提醒
    window.onbeforeunload = function (e) {
      (e || window.event).returnValue = "确定离开此页吗？";
    };

    const direMap = {
      1: 0,
      2: 2,
    };

    this.EDITOR = new AnimEditor("editor", {
      width: this.Tool_Size.width,
      height: this.Tool_Size.height - 40,
      surplusY: this.TopNav_Size.height + 40,
      surplusX: this.MaterialPane_Size.width,
      optimized: this.$route.direction == 2 ? 2 : 0,
    });

    this.$store.commit("addSoundtrack/setSoundObj", AnimEditor.soundPlayHandle);

    this.$store.commit("save_Tool", this.EDITOR);

    this.TOOL.on("selectScenes", (selected) => {
      // 选中分组
      this.$store.commit("save_SelectScenesMsg", selected);
    });

    this.TOOL.on("selectSprite", (selected) => {
      // 选中元素
      if (selected.length) {
      }
      this.$store.commit("save_SelectSpritesMsg", selected);
    });

    this.TOOL.on("updateSprite", (data) => {
      // 修改元素
      this.$bus.emit("updateSprite_vue", data);
    });

    this.TOOL.on("spriteSetting", (data) => {
      // 元素操作返回事件
      this.$bus.emit("changeSelectScenes_vue", data.scenes); // 元素操作返回事件
    });

    this.TOOL.on("spriteAdded", (data, { isSwap, spriteType, update } = {}) => {
      // 添加元素
      this.$bus.emit("spritesExitChange", { data: true });

      if (data && data.option && !data.option.groupId) {
        this.$bus.emit("addCanvas", data);
      } else if (spriteType === "background") {
        this.$bus.emit("addCanvas");
      }

      let scenesData = this.TOOL.getScenesIdData(data.scenesId);
      if (isSwap || this.SpriteOperation === "swap") {
        this.$bus.emit("spriteSwapped_vue", scenesData);
      } else {
        this.$bus.emit("spriteAdded_vue", scenesData, { spriteType, update }); // 元素添加
      }
      this.$bus.emit("changeSelectScenes_vue", scenesData); // 分组缩略图
      if (spriteType !== "background") {
        this.judgeItemPayType(data); // 判断付费素材

        if (
          data.option.isUser &&
          data.option.fileType &&
          this.isUUID(data.option.resourceId)
        ) {
          let userMaterials = this.TOOL.userMaterials || [];
          if (
            userMaterials &&
            !userMaterials.some((v) => v.id === data.option.resourceId)
          ) {
            userMaterials.push({
              fileType: data.option.fileType,
              id: data.option.resourceId,
            });
            this.TOOL.userMaterials = userMaterials;
          }
        }
      }
    });

    this.TOOL.on("FeaturesPop", (data) => {
      // 弹窗
      this.$bus.emit("FeaturesPop_vue", data);
    });

    this.TOOL.on("changeSelectScenes", (data) => {
      // 改变缩略图
      this.$bus.emit("changeSelectScenes_vue", data); // 分组缩略图
    });

    this.TOOL.on("removeSprite", (data) => {
      // 元素删除
      this.$store.commit("del_vipSprites", { id: data.id });
      this.$bus.emit("spritesExitChange", { data: true });
      this.vipMaterialsAndVipFunctions();
      this.judgeToolVideo(true);

      let userMaterials = this.TOOL.userMaterials || [];
      this.TOOL.userMaterials = userMaterials.filter(
        (v) => v.id !== data.data.option.resourceId
      );
    });

    this.TOOL.on("removeScenes", (data) => {
      // 数组删除
      // console.log(data, 'rm_scenesVipSprites');
      this.$bus.emit("spritesExitChange", { data: true });
      this.$store.commit("rm_scenesVipSprites", { id: data.id });

      this.judgeToolVideo(true);
    });

    this.TOOL.on("scenesFormJson", (data) => {
      // 场景改变
      if (this.allFormJson) {
        let scenesData = this.TOOL.getScenesIdData(data.id); // 场景
        if (scenesData.resourceId) {
          this.$bus.emit("judgeItemPayType_vue", {
            type: "scenes",
            id: scenesData.id,
            option: {
              resourceId: scenesData.resourceId, // 背景资源id
              fileType: 24, // 背景资源type
            },
            opHelper: {
              isSvip: false,
            },
            scenesId: scenesData.id,
          });
        } else {
          this.$store.commit("rm_scenesVipSprites", { id: data.id });
        }

        let bgData = scenesData.background.data; // 背景
        if (bgData.type === "Image" || bgData.type === "Video") {
          this.$bus.emit("judgeItemPayType_vue", {
            type: "bg",
            id: "BG-" + scenesData.id,
            option: {
              resourceId: bgData.resourceId, // 背景资源id
              fileType: bgData.fileType, // 背景资源type
            },
            opHelper: {
              isSvip: false,
            },
            scenesId: scenesData.id,
          });
          // console.log(bgData, '场景改变');
        } else {
          this.$store.commit("del_vipSprites", { id: "BG-" + scenesData.id });
        }
      }
    });

    this.TOOL.on("dbClickCropImage", (data) => {
      if (data.cropType !== "svg") {
        this.$bus.emit("cropfreelayer");
      } else {
        this.$bus.emit("cropsvglayer");
      }
      this.$bus.emit("FeaturesPop_vue", {
        name: "cropping",
        type: 1,
        sprite: this.SelectSprites_Msg[0],
      });
    });

    this.$bus.on("hintMessage_vue", (data) => {
      // formjson所有信息
      if (data.data) {
        let timeoutid = setTimeout(() => {
          this.spritesMsg = true;
          clearTimeout(timeoutid);
        }, 2000);
      } else {
        this.$bus.emit("app.checkedMaterialOnOpenPage");
      }
    });

    this.TOOL.initScenes().then((scenes) => {
      this.EDITOR.selectScenes(scenes);
      if (this.TOOL.sprites.length === 1) {
        this.TOOL.sprites[0].fromJsonLoadingState = 2;
      }
    });

    this.$bus.on("SwitchStyleTip", (data) => {
      // 切换导航 提醒
      this.SwitchStyleTip = 1;
    });

    window.onscroll = () => {
      // window滚动条
      let data = {
        top: 0,
        left: 0,
      };
      if (document.body.scrollTop) {
        data.top = document.body.scrollTop;
      } else {
        data.top = document.documentElement.scrollTop;
      }
      if (document.body.scrollLeft) {
        data.left = document.body.scrollLeft;
      } else {
        data.left = document.documentElement.scrollLeft;
      }
      this.$store.commit("save_scoll", data);
    };
    window.onclick = (e) => {
      // window点击事件
      this.$bus.emit("window_click", {
        data: e,
      });

      if (this.SwitchStyleTip == 1) {
        // 切换导航 提醒
        this.SwitchStyleTip = 2;
      } else if (this.SwitchStyleTip == 2) {
        this.SwitchStyleTip == 0;
        this.$bus.emit("SwitchStyleTip", { data: false });
      }
      // 关闭选色层
      this.$bus.emit("eyedropperBox.hide");
    };
    // 通过给window绑定online、offline事件来实现网络连接或断开时的事件；
    if (window.navigator.onLine === true) {
      this.$bus.emit("Modal_close_vue", { name: "internet" });
    } else {
      this.$bus.emit("Modal_vue", { name: "internet" });
    }
    window.addEventListener("online", () => {
      this.$bus.emit("Modal_close_vue", { name: "internet" });
    });
    window.addEventListener("offline", () => {
      this.$bus.emit("Modal_vue", { name: "internet" });
    });

    this.TOOL.on("emitText", (data) => {
      this.$bus.emit("updateText", data);
    });

    this.judgeStyle(); // 判断style风格是否存在

    // 开发使用
    if (this.$route.debug === "true") {
      window._editor = this.TOOL;
      window.soundPlayHandle = AnimEditor.soundPlayHandle;
    }

    this.$bus.on("judgeItemPayType_vue", (data) => {
      this.TOOL.eve.once("sceneBgAdded", () => {
        this.requestCheckCommercial();
      });
      // 判断元素的付费类型
      this.judgeItemPayType(data, { willCheckCommercial: true });
      // this.requestCheckCommercial();
    });

    let storyboard = this.$route.storyboard,
      template = this.$route.template,
      projectId = this.$route.projectId;
    if (!storyboard && !template && !projectId) {
      this.spritesMsg = true;
      // console.log(this.$route, '通过给window绑定online、offline事件来实现网络连接或断开时的事件；');
    }

    // 获取默认字体
    this.downFonts.forEach((font) => this.loadFonts(font.value));
    // 加载项目时的字体下载列表存入vux
    this.TOOL.on("updateFontList", (toolFont) => {
      this.getCheckFont(toolFont);
    });

    this.$bus.on("undoRedoHandle", (data) => {
      if (data.type == "removeScenes") {
        this.scenesUndoRudo = true;
      }
    });

    this.$bus.on("addTemplate", async (data) => {
      console.log(`Turbo ~ this.$bus.on ~ data:`, data)
      let willShow = () => {
        // if ([1, 4, 6].indexOf(data.payType) > -1 && !data.tt) {
        //   if (this.isPersonVip || this.isTmpSolo) {
        //     return data.payType === 6;
        //   } else if (this.UserLevelType > 0 || this.UserMsg.tmpLevelType > 0) {
        //     return false;
        //   } else {
        //     return true;
        //   }
        // }
        const levelCode = this.UserLevelInfo.levelCode;
        const levelType = this.UserMsg.levelType || 0;
        const levelId = this.UserMsg.level;
        if (this.IsOldUser) {
          if ([1, 4].includes(data.payType)) {
            return levelCode >= 1 ? false : true;
          }
          if ([2, 3, 6].includes(data.payType)) {
            return levelCode >= 2
              ? false
              : true;
          }
          return false;
        } else if (this.IsProLevelSystem) {
          if ([1, 4].includes(data.payType)) {
            return levelType >= 3 ? false : true;
          }
          if ([2, 3, 6].includes(data.payType)) {
            return levelType >= 2 ? false : true;
          }
        } else {
          if ([1, 4].includes(data.payType)) {
            return this.IsEnjoymentLevel ? false : true;
          }
          if ([2, 3, 6].includes(data.payType)) {
            const isEnterpriseLevel = levelCode === 2;
            const isShopLevel = levelCode === 1 && this.UserMsg.levelNewType === 6;
            const isEducationLevel = [147, 148].includes(levelId);
            return isEnterpriseLevel || isShopLevel || isEducationLevel
              ? false
              : true;
          }
          return false;
        }
      };

      let shouldShow = true;
      if (!willShow()) {
        const respTemp = await this.$http
          .get("/api/common/material/templateData", {
            params: {
              id: data.id,
            },
          })

        if (respTemp.data.code === 200) {
          shouldShow = false;
        }
      }

      if (
        /* (this.UserEquity.exclusiveBtn || this.isPersonVip || this.isPoor) &&
        [1, 4, 6].indexOf(data.payType) > -1 &&
        !data.tt */
        // willShow()
        shouldShow
      ) {
        this.payvisible = true;
        this.$set(this, "payvisible", true);
        this.currentTemplate = data;
        this.$bus.emit("payPanel.show");
        let item = data || {};
        sensors.track("templateBuyNow", {
          author_id: this.UserMsg.id,
          author_name: this.UserMsg.nickname,
          business: "",
          content_duration: this.TOOL.getDuration() / 1000,
          price_type: ((payType) => {
            if (payType == 0) {
              return "免费";
            }
            if (payType == 1) {
              return "付费";
            }
            if (payType == 4) {
              return "会员免费";
            }
            return "全部价格";
          })((item || {}).payType),
          price: item.price - 0,
          purpose: "",
          source: "编辑器-素材弹窗",
          template_id: item.id,
          template_name: item.title,
          template_style: "",
          template_type: "",
        });
        const cate = data.payType === 6 ? "企业会员" : "个人会员";
        sensors.track("doratoonGuideePopup", {
          popup_content: "会员模板", // 弹窗引导内容
          restricted_function: "会员模板", // 受限功能
          popup_category1: [cate, "模板"], // 弹窗分类
        });
      } else {
        this.$store.commit("open_sideBarTemplate", {
          sideBarTemplate: data,
        });
      }
    });

    this.$bus.on("openPayTemplatePanel", (data) => {
      this.payvisible = true;
      this.currentTemplate = data;
      this.$bus.emit("payPanel.show");
    });

    this.$bus.on("payPriceEvent_vue", (data) => {
      this.scenesAllSprites(true).then((res) => {
        let fallback = {
          payList: [],
        };
        let hasPayList = (res.data || fallback).payList.length;
        this.$bus.emit("FeaturesPop_close_vue", {
          name: "vipPayment",
          type: 2,
        });
        if (hasPayList) {
          this.$bus.emit("FeaturesPop_vue", {
            name: "vipPayment",
            msg: "您的付款还没有成功哦",
            btnClose: "查看帮助", // 左侧按钮信息
            btnMsg: "联系客服", // 右侧按钮信息
            btnMsgFs: 1, // 判断是否有按钮事件1开始
            fs: "payment",
            msgType: 0, // 0--左链接，右按钮；1--双链接；2--双按钮
            type: 2,
          });
        }

        this.$bus.emit("payPriceEventHref_vue", { type: data.type });
      });
    });

    // 新手引导(初次加载)
    eve.on("windowLoading", async (data) => {
      window._firstOpen = this.UserMsg.versionNumber <= 400;
      const resp = await this.$http.get('/api/user/info/record', {
        params: {
          type: 14
        }
      });
      const respOld = await this.$http.get('/api/user/info/record', {
        params: {
          type: 8
        }
      });
      const hasOpenNew = resp.data.data;
      if (!respOld.data.data) {
        await this.$http.post('/api/user/info/record', {
          type: 8
        });
      }
      // if (!recordResp.data.data) {
      if (this.UserMsg.versionNumber <= 400) {
        // record and add 24 hours
        await this.$http.post('/api/user/info/record', {
          type: 8
        });
        const sessionResp = await this.$http.get("/api/session");
        this.$store.commit("toggle_UserMsg", sessionResp.data.data);
        if (!this.$route.userTask) {
          const levelMatched = this.UserLevelInfo.levelName === 'basic' || this.UserLevelInfo.levelName === 'person' && this.UserLevelInfo.trial;
          if (false && !hasOpenNew && levelMatched) {
          } else {
            this.$bus.emit("getApiCourse");
            this.$store.commit("save_TopnavMsg", {
              isShowAnimCourseDialog: true,
            });
          }
        }
        if (this.UserMsg.guidance === "4.0.0") return;
        setTimeout(() => {
          this.$http.post("/api/user/info/guidance", {
            // guidance: '4.6.0'
            guidance: this.versionToolFS(),
          });
        }, 3000);
      } else if (this.UserMsg.versionNumber != this.UserMsg.versionTOOL) {
        this.$http.post("/api/user/info/guidance", {
          // guidance: '4.6.0'
          guidance: this.versionToolFS(),
        });

        const isOpenPresentationTip = localStorage.getItem('isOpenPresentationTip');
        if (!isOpenPresentationTip) {
          this.$bus.emit('openPresentationTip');
          localStorage.setItem('isOpenPresentationTip', '1');
        }
      }
    });
    this.TOOL.eve.on("loadBgError", ({ type } = {}) => {
      let dict = {
        Video: "视频",
        Image: "图片",
      };
      if (dict[type]) {
        // this.message && typeof this.message.close === 'function' && this.message.close();
        if (!$(`.error-toast-${type}`).length) {
          this.$message({
            // message: `${dict[type]}背景加载失败`,
            // message: `该素材因内容违规,无法正常使用。请使用其他素材。`,
            message: `素材加载失败，请刷新重试。`,
            type: "error",
            customClass: `error-toast-${type}`,
          });
        }
      }
    });

    this.$bus.on("timeline_play_all", (data) => {
      AnimEditor.soundPlayHandle.play(data);
    });
    this.$bus.on("timeline_play_scenes", (data) => {
      AnimEditor.soundPlayHandle.play(data);
    });
  },
  beforeDestroy() {},
  methods: {
    ...mapActions({
      category: "resources/category",
      getTemplateCate: "resources/getTemplateCate",
      search: "resources/search",
      searchScene: "resources/searchScene",
      searchTemplate: "resources/searchTemplate",
      searchBackground: "resources/searchBackground",
      searchText: "resources/searchText",
      searchCharacter: "resources/searchCharacter",
      searchMaterial: "resources/searchMaterial",
      searchSound: "resources/searchSound",
      searchAll: "resources/searchAll",
      getPayTypes: "resources/getPayTypes",
      getRecent: "resources/getRecent",
      setRecent: "resources/setRecent",
      getSpaceSize: "resources/getSpaceSize",
      getUserCate: "resources/getUserCate",
      getUploaded: "resources/getUploaded",
      searchUserItem: "resources/searchUserItem",
      getTeamItems: "resources/getTeamItems",
    }),
    async testMine() {
      let resp = await this.getSpaceSize();
      resp = await this.getUploaded({
        params: {
          type: "draft",
        },
        options: {
          type: "team",
        },
      });
      console.log("turbo: testMine -> 团队模板", resp);
      resp = await this.getUserCate({
        params: {
          type: "draft",
        },
        options: {
          type: "team",
        },
      });
      console.log("turbo: testMine -> 团队模板文件夹", resp);

      resp = await this.searchUserItem({
        keyword: "图",
        options: {
          type: "team",
        },
      });
      console.log("turbo: testMine -> 团队素材数", resp);

      resp = await this.getTeamItems({
        keyword: "图",
        type: "image",
      });
      console.log("turbo: testMine -> 团队素材", resp);
    },
    async testApi() {
      let payTypes = await this.getPayTypes();
      console.log("turbo: testApi -> this.getPayTypes()", payTypes);

      let resp = await this.searchTemplate({
        params: {},
      });
      console.log("turbo: testApi -> resp template", resp);

      resp = await this.searchMaterial({
        params: {
          style: void 0,
        },
        options: {
          type: "likes",
        },
      });
      console.log("turbo: testApi -> resp 道具收藏", resp);
    },
    onSceneSoundUpdate() {
      // 加载分组音乐
      if (this.allFormJson) {
        let scenes = this.SelectScenes_Msg.toJson();
        if (
          this.SelectScenes_Msg.sound &&
          this.SelectScenes_Msg.sound.url &&
          !this.UserEquity.uploadSound
        ) {
          let judgeVip = this.judgeSoundBgIsVip(
            "ScenesSound" + this.SelectScenes_Msg.id
          );
          if (judgeVip) {
            let sound = this.SelectScenes_Msg.toJson().sound[0];
            this.$store.commit("push_vipSprites", {
              id: "ScenesSound" + this.SelectScenes_Msg.id,
              type: "ScenesSound",
              scenesId: this.SelectScenes_Msg.id,
              resourceId: sound.resourceId,
            });
            let isCoworker = this.isCoworker();
            !isCoworker &&
              this.$message({
                showClose: true,
                message:
                  "您正在使用VIP功能或资源，若您需要导出视频，还请升级会员。",
                type: "error",
              });
          }
        } else {
          this.$store.commit("del_vipSprites", {
            id: "ScenesSound" + scenes.id,
          });
        }
        this.requestCheckCommercial();
      }
    },
    loadFonts(font) {
      let _this = this;
      // 下载字体
      fetch(this.$handleAssetsUrl(font), {
        methods: "GET",
        mode: "cors",
      })
        .then(function (res) {
          if (!res.ok) console.error('load font "' + font + '" fail:', res);
          // 添加font-face
          var style =
            '<style type="text/css">\n' +
            "@font-face {" +
            'font-family: "' +
            font.split("/").pop() +
            '";' +
            'src: url("' +
            res.url +
            '");';
          var visualDom = "<div>来画动画</div>";
          $("head").prepend(style);
          $(visualDom)
            .appendTo($("body"))
            .css({
              fontFamily: `"${font.split("/").pop()}"`,
              visibility: "hidden",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: -10,
            });
          return Promise.resolve();
        })
        .catch((err) => {
          console.log(err);
          return Promise.resolve();
        });
    },
    windowSize() {
      const nameOfCommit = this.openSubtitle ? 'save_WindowSubtitle' : 'save_Window';
      this.$store.commit(nameOfCommit, {
        width: document.body.clientWidth,
        height: document.body.clientHeight,
      });
      this.$bus.emit("EditorSetOption_vue", {
        data: true,
        source: "app",
      });
    },
    judgeStyle() {
      // 判断style风格是否存在
      if (isNaN(this.StyleMsg) || !this.StyleMsg) {
        // 判断不是模版类型
        // this.$bus.emit("Modal_vue", { name: "style" });
      } else {
        this.$bus.emit("Modal_close_vue", { name: "style" });
      }
    },
    isUser(data) {
      return data && data.trackingType && data.trackingType[0] === "1";
    },
    notUser(data) {
      // return !this.isUser(data);
      return true;
    },
    formatEditorData() {
      let list = [];
      let editor = this.TOOL;
      let scenes = this.TOOL.sprites;
      let itemData = {
        id: "",
        resourceId: "",
        fileType: "",
        scenesId: "",
        thumbnailUrl: "",
      };
      if (this.musicArr && this.musicArr.length) {
        this.musicArr.forEach((v) => {
          let item = {
            id: this.getNewSoundId({ type: "2" }),
            scenesId: "sound",
            resourceId: v.id,
            fileType: v.fileType,
            thumbnailUrl: "",
            type: "sound",
            soundType: "music",
            timeSlot: v.timeSlot,
          };
          list.push(item);
        });
      }
      if (this.dubbingArr && this.dubbingArr.length) {
        this.dubbingArr.forEach((v) => {
          let item = {
            id: this.getNewSoundId({ type: "1" }),
            scenesId: "sound",
            resourceId: v.id,
            fileType: v.fileType,
            thumbnailUrl: "",
            type: "sound",
            soundType: "dubbing",
            timeSlot: v.timeSlot,
          };
          list.push(item);
        });
      }

      if (
        this.TOOL.sound &&
        this.TOOL.sound.url &&
        this.TOOL.sound.resourceId &&
        this.TOOL.sound.fileType &&
        this.notUser(this.TOOL.sound)
      ) {
        let item = {
          id: "TOOLsound",
          resourceId: editor.sound.resourceId,
          fileType: editor.sound.fileType,
          scenesId: "TOOLsound",
          thumbnailUrl: "",
          type: "TOOLsound",
        };
        list.push(item);
      }
      if (
        editor.soundRecord &&
        editor.soundRecord.fileType &&
        editor.soundRecord.resourceId &&
        this.notUser(editor.soundRecord)
      ) {
        let item = {
          id: "AllSound",
          scenesId: "AllSound",
          resourceId: editor.soundRecord.resourceId,
          fileType: editor.soundRecord.fileType,
          thumbnailUrl: "",
          type: "AllSound",
        };
        list.push(item);
      }
      for (let i = 0; i < scenes.length; i++) {
        let scene = scenes[i];
        let bgType = scene.background.data.type;
        let isMediaBg = bgType === "Image" || bgType === "Video";
        if (isMediaBg && this.notUser(scene.background.data)) {
          let url = scene.background.data.data.url;
          let item = {
            type: "bg",
            id: "BG-" + scene.id,
            resourceId: scene.background.data.resourceId,
            fileType: scene.background.data.fileType,
            scenesId: scene.id,
            thumbnailUrl: url,
          };
          list.push(item);
        }
        if (
          scene.sound &&
          scene.sound.url &&
          scene.sound.resourceId &&
          this.notUser(scene.sound)
        ) {
          let item = {
            id: "ScenesSound" + scene.id,
            resourceId: scene.sound.resourceId,
            fileType: scene.sound.fileType,
            scenesId: scene.id,
            thumbnailUrl: "",
            type: "ScenesSound",
          };
          list.push(item);
        }
        for (let j = 0; j < scene.sprites.length; j++) {
          let sprite = scene.sprites[j];
          let rid = sprite.option.resourceId;
          let ridFlag =
            rid &&
            /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
              rid
            );
          let ft = sprite.option.fileType;
          if (!ft || !ridFlag) {
          }
          if (
            sprite.type !== "RichText" &&
            sprite.type !== "Text" &&
            sprite.fileType != 15 &&
            ridFlag &&
            ft &&
            this.notUser(sprite.option)
          ) {
            let fileType = sprite.option.fileType;
            let resourceId = sprite.option.resourceId;
            let item = {
              id: sprite.id,
              resourceId,
              fileType,
              scenesId: sprite.option.scenesId,
              thumbnailUrl: (sprite.option.url || "").replace(
                /\.[a-z1-9]+$/,
                "nail.png"
              ),
              // groupId: sprite.option.groupId,
            };
            if (sprite.option.groupId) {
              const groupInfo = sprite.option.groupId;
              const groupInList = list.some(
                (v) => v.resourceId === sprite.option.groupId.resourceId
              );
              if (!groupInList) {
                item = {
                  isGroup: true,
                  ...groupInfo,
                };
                list.push(item);
              }
            } else {
              list.push(item);
            }
          }

          // if (sprite.type === 'RichText') {
          //   let arr = sprite.option.resourceIds || [];
          //   arr.forEach(v => {
          //     let item = {
          //       id: sprite.id,
          //       resourceId: v,
          //       fileType: 15,
          //       scenesId: sprite.option.scenesId,
          //       thumbnailUrl: (sprite.option.url || '').replace(/\.[a-z1-9]+$/, 'nail.png'),
          //       groupId: sprite.option.groupId
          //     };
          //     list.push(item);
          //   })
          // } else {
          //   let fileType = sprite.option.fileType;
          //   // e629e28b-df72-4767-a6d3-695c50c841e7
          //   let resourceId = sprite.option.resourceId;
          //   if (!fileType && sprite.type === 'Text') {
          //     fileType = 15;
          //   }
          //   if (!resourceId && sprite.type === 'Text') {
          //     resourceId = 'e629e28b-df72-4767-a6d3-695c50c841e7';
          //   }
          //   let item = {
          //     id: sprite.id,
          //     resourceId,
          //     fileType,
          //     scenesId: sprite.option.scenesId,
          //     thumbnailUrl: (sprite.option.url || '').replace(/\.[a-z1-9]+$/, 'nail.png'),
          //     groupId: sprite.option.groupId
          //   }
          //   list.push(item);
          // }
        }
      }

      console.log(`Turbo ~ formatEditorData ~ list`, list)
      list = list.filter(
        (v) =>
          v.fileType &&
          v.fileType != 50 &&
          /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
            v.resourceId
          )
      );
      list = uniqueElementsBy(
        list,
        (a, b) => a.id === b.id && a.resourceId === b.resourceId
      );
      return list;
    },
    checkCommercialRiskList(list, AIGCItems) {
      // if (list && !list.length) {
      //   this.$store.commit('setCommercialRisk', this.formattedEditor);
      // }
      // this.formatEditorData();

      list.forEach((v) => {
        this.checkCRiskItem(v);
      });
      this.formattedEditor.forEach(v => {
        if (AIGCItems && AIGCItems.some(x => x.id === v.resourceId)) {
          v.typeName = 'AIGC';
        }
      })
      this.$store.commit("setCommercialRisk", this.formattedEditor);
    },
    checkCRiskItem(item, AIGCItems) {
      let cRisk = this.formattedEditor || this.$store.getters["CommercialRisk"];
      for (let i = 0; i < cRisk.length; i++) {
        if (cRisk[i].id === item.uuid) {
          cRisk.splice(i, 1);
        }
      }
      cRisk = uniqueElementsBy(
        cRisk,
        (a, b) => a.id === b.id && a.resourceId === b.resourceId
      );
      // this.$store.commit('setCommercialRisk', cRisk);
      this.formattedEditor = cRisk;
    },
    async requestCheckCommercial() {
      if (this.willCheckMaterial === false) {
        return;
      }
      let cRisk = this.formatEditorData();
      this.formattedEditor = cRisk;
      let reqList = cRisk.map((v) => {
        let item = { ...v };
        item.uuid = v.id;
        item.id = v.resourceId;
        return item;
      });
      let commercialResp = await this.$http.post(
        "/api/user/material/checkCommercial",
        {
          dataList: JSON.stringify(reqList),
          draftId: this.WorksId,
        }
      );
      let commercial = commercialResp.data.data || {};
      commercial = commercial.commercial;
      this.checkCommercialRiskList(commercial || [], commercialResp.data.data.aiData);
    },
    handleToRemove(arr, sprite) {
      let toRemoveList = this.$store.getters["toRemoveList"];
      let added = arr.map((data) => {
        return {
          id: sprite.id,
          type: sprite.type,
          scenesId: sprite.scenesId,
          resourceId: sprite.option.resourceId,
          title: data && data.title,
          thumbnailUrl: data && data.thumbnailUrl,
          commercial: false,
        };
      });
      toRemoveList = [...toRemoveList, ...added];
      toRemoveList = uniqueElementsBy(
        toRemoveList,
        (a, b) => a.id === b.id && a.resourceId === b.resourceId
      );
      this.$store.commit("setToRemoveList", toRemoveList);
    },
    async scenesAllSprites(preCheck) {
      if (this.willCheckMaterial === false) {
        return;
      }
      if (this.isCoworker()) {
        return;
      }
      // 获取所有元素的性质
      let scenes = this.TOOL.sprites;
      let spritesData = [],
        EchartList = [],
        scenesSound = [];

      if (this.musicArr && this.musicArr.length) {
        this.musicArr.forEach((v) => {
          let item = {
            FT: v.FT,
            id: v.id,
            uuid: this.getNewSoundId({ type: "2" }),
            scenesId: "sound",
            fileType: v.fileType,
            type: "sound",
            soundType: "music",
            timeSlot: v.timeSlot,
          };
          spritesData.push(item);
        });
      }
      if (this.dubbingArr && this.dubbingArr.length) {
        this.dubbingArr.forEach((v) => {
          let item = {
            FT: v.FT,
            id: v.id,
            uuid: this.getNewSoundId({ type: "1" }),
            scenesId: "sound",
            fileType: v.fileType,
            type: "sound",
            soundType: "dubbing",
            timeSlot: v.timeSlot,
          };
          spritesData.push(item);
        });
      }

      if (
        this.TOOL.sound &&
        this.TOOL.sound.url &&
        this.TOOL.sound.resourceId &&
        this.TOOL.sound.fileType
      ) {
        spritesData.push({
          id: this.TOOL.sound.resourceId,
          uuid: "TOOLsound",
          fileType: this.TOOL.sound.fileType,
          scenesId: "TOOLsound",
          resourceId: this.TOOL.sound.resourceId,
          type: "TOOLsound",
        });
      }
      if (this.TOOL.soundRecord /* && !this.UserEquity.uploadSound */) {
        spritesData.push({
          id: this.TOOL.soundRecord.resourceId,
          type: "AllSound",
          scenesId: "AllSound",
          resourceId: this.TOOL.soundRecord.resourceId,
          fileType: this.TOOL.soundRecord.fileType,
        });
      }
      for (let i = 0; i < scenes.length; i++) {
        if (
          scenes[i].background.data.resourceId &&
          scenes[i].background.data.fileType
        ) {
          // 背景
          spritesData.push({
            FT: scenes[i].background.FT,
            id: scenes[i].background.data.resourceId,
            uuid: scenes[i].id,
            fileType: scenes[i].background.data.fileType,
            scenesId: scenes[i].id,
          });
        }
        let sceneResourceId =
          scenes[i].resourceId || scenes[i].options.resourceId;
        if (sceneResourceId) {
          // 场景
          spritesData.push({
            FT: scenes[i].FT,
            id: sceneResourceId,
            fileType: 24,
            scenesId: scenes[i].id,
            uuid: scenes[i].id,
          });
        }
        if (
          scenes[i].sound &&
          scenes[i].sound
            .url /* && !this.UserEquity.uploadSound && !this.TOOL.soundRecord */
        ) {
          // 场景音乐
          spritesData.push({
            id: "ScenesSound" + scenes[i].id,
            type: "ScenesSound",
            scenesId: scenes[i].id,
            resourceId: scenes[i].sound.resourceId,
          });
        }
        for (let t = 0; t < scenes[i].groupList.length; t++) {
          let groupData = scenes[i].groupList[t];
          spritesData.push({
            id: groupData.resourceId,
            type: groupData.type,
            uuid: groupData.id,
            fileType: groupData.fileType,
            scenesId: scenes[i].id,
          });
        }
        // let mySprites = preCheck ? (scenes[i].preSprites || scenes[i].sprites) : scenes[i].sprites;
        for (let t = 0; t < scenes[i].sprites.length; t++) {
          let sprite = scenes[i].sprites[t] || {};
          // this.judgeItemPayType_(sprite);
          // if (preCheck && i > 0) {
          //   sprite = scenes[i].preSprites[t];
          // }
          sprite.opHelper && sprite.opHelper.showHideSvip(false, false, true);

          if (!sprite.groupId) {
            if (sprite.option.resourceId && sprite.option.fileType) {
              spritesData.push({
                FT: sprite.FT,
                id: sprite.option.resourceId,
                uuid: sprite.id,
                fileType: sprite.option.fileType,
                scenesId: scenes[i].id,
              });
            }

            let vipSpritesCode = false;
            if (sprite.option.resourceIds && sprite.option.resourceIds.length) {
              let list = sprite.option.resourceIds.map((v) => {
                return {
                  FT: sprite.FT,
                  id: v,
                  uuid: sprite.id,
                  fileType: sprite.option.fileType || 15,
                  scenesId: scenes[i].id,
                };
              });
              spritesData.push(...list);
            }
            switch (sprite.type) {
              case "Chart":
                vipSpritesCode = true;
                break;
              case "Text":
                // case 'RichText':
                if (sprite.option.resourceId) {
                  spritesData.push({
                    id: sprite.option.resourceId,
                    uuid: sprite.id,
                    fileType: sprite.option.fileType || 15,
                    scenesId: scenes[i].id,
                  });
                }
                // else if (sprite.option.resourceIds && sprite.option.resourceIds.length) {
                //   let list = sprite.option.resourceIds.map(v => {
                //     return {
                //       id: v,
                //       uuid: sprite.id,
                //       fileType: sprite.option.fileType || 15,
                //       scenesId: scenes[i].id
                //     }
                //   });
                //   spritesData.push(...list);
                // }
                if (sprite.type === "Text") {
                  for (let t = 0; t < this.styleObject.length; t++) {
                    let textAttrData = this.styleObject[t];
                    if (
                      textAttrData.isVip == 1 &&
                      sprite.artType == textAttrData.val &&
                      sprite.option &&
                      !sprite.option.templateFree
                    ) {
                      if (!this.UserEquity.exclusive) {
                        vipSpritesCode = true;
                      }
                      break;
                    }
                  }
                }
                break;
            }
            if (vipSpritesCode) {
              if (sprite.type == "Chart" && !this.UserEquity.Echart) {
                EchartList.push({
                  id: sprite.id,
                  type: sprite.type,
                  scenesId: scenes[i].id,
                });
                this.addSvipLabel(sprite, { payType: 6, fileType: "echart" });
              } else if (
                sprite.type == "Text" &&
                !EchartList.find((v) => v.id === sprite.id)
              ) {
                EchartList.push({
                  artword: sprite.artType,
                  id: sprite.id,
                  type: sprite.type,
                  scenesId: scenes[i].id,
                });
                this.addSvipLabel(sprite, { payType: 4 });
              }
              (sprite.opHelper || {}).isSvip = this.UserLevelName;
            }
          }
        }
      }
      scenes = null;
      if (EchartList.length && !this.UserEquity.Echart) {
        this.$store.commit("push_vipSprites", {
          data: EchartList,
          action: true,
        });
      }

      let formatted = this.formatEditorData();
      this.formattedEditor = formatted;
      let reqList = formatted.map((v) => {
        let item = { ...v };
        item.uuid = v.id;
        item.id = v.resourceId;
        return item;
      });
      let commercialResp = await this.$http.post(
        "/api/user/material/checkCommercial",
        {
          dataList: JSON.stringify(reqList),
          draftId: this.WorksId,
        }
      );
      let commercial = commercialResp.data.data || {};
      commercial = commercial.commercial;
      this.checkCommercialRiskList(commercial || [], commercialResp.data.data.aiData);
      console.log(
        `turbo: scenesAllSprites -> spritesData.filter(v => v.FT)`,
        spritesData.filter((v) => v.FT)
      );
      spritesData = spritesData.filter((v) => !v.FT);
      return this.$http
        .post("/api/user/material/checkMaterial", {
          dataList: JSON.stringify(spritesData),
          draftId: this.WorksId,
        })
        .then((res) => {
          if (res.data.code !== 200) return;
          //  请求发出检测元素的paytype
          let limitdata = res.data.data;
          let dataArray = [];
          let arr = [];
          let cArr = [];
          let toRemoveList = [];
          for (let itemName in limitdata) {
            switch (itemName) {
              case "payList":
                limitdata[itemName].forEach((respItem) => {
                  let f = spritesData.filter((v) => {
                    let isSameId = v.id === respItem.id;
                    if (respItem.price != null && isSameId) {
                      v.price = respItem.price;
                    }
                    if (isSameId) {
                      v.payType = respItem.payType;
                      v.thumbnailUrl = respItem.thumbnailUrl;
                      v.title = respItem.title;
                      v.commercial = false;
                      // if (respItem.timeSlot) {
                      //   v.timeSlot = respItem.timeSlot;
                      // }
                    }
                    return isSameId;
                  });
                  arr.push(...f);
                });
                // this.judgeLimitdata(limitdata[itemName], dataArray, spritesData);
                break;
              case "vipList":
                limitdata[itemName].forEach((respItem) => {
                  let f = spritesData.filter((v) => {
                    let isSameId = v.id === respItem.id;
                    if (respItem.payType != null && isSameId) {
                      v.payType = respItem.payType;
                    }
                    if (isSameId) {
                      v.thumbnailUrl = respItem.thumbnailUrl;
                      v.title = respItem.title;
                      v.commercial = false;
                      // if (respItem.timeSlot) {
                      //   v.timeSlot = respItem.timeSlot;
                      // }
                    }
                    return isSameId;
                  });
                  arr.push(...f);
                });
                // this.judgeLimitdata(limitdata[itemName], dataArray, spritesData);
                break;
              case "removedMaterials":
                limitdata[itemName].forEach((respItem) => {
                  let f = spritesData.filter((v) => {
                    let isSameId = v.id === respItem.materialUid;
                    if (isSameId) {
                      v.thumbnailUrl = respItem.thumbnailUrl;
                      v.title = respItem.title;
                      v.commercial = false;
                      v.removed = true;
                      // if (respItem.timeSlot) {
                      //   v.timeSlot = respItem.timeSlot;
                      // }
                    }
                    return isSameId;
                  });
                  arr.push(...f);
                });
                break;
              case "toRemoveMaterials":
                limitdata[itemName].forEach((respItem) => {
                  let f = spritesData.filter((v) => {
                    let isSameId = v.id === respItem.materialUid;
                    if (isSameId) {
                      v.thumbnailUrl = respItem.thumbnailUrl;
                      v.title = respItem.title;
                      v.commercial = false;
                      v.toRemove = true;
                    }
                    return isSameId;
                  });
                  toRemoveList.push(...f);
                });
                toRemoveList = uniqueElementsBy(
                  toRemoveList,
                  (a, b) => a.id === b.id && a.uuid === b.uuid
                );
                let riskList = [];
                this.judgeLimitdata(toRemoveList, riskList, spritesData);
                this.$store.commit("setToRemoveList", riskList);
                break;
              case "commercial":
                limitdata[itemName].forEach((respItem) => {
                  let f = spritesData.filter((v) => {
                    let isSameId = v.id === respItem.id;
                    if (isSameId) {
                      v.thumbnailUrl = respItem.thumbnailUrl;
                      v.title = respItem.title;
                      v.commercial = true;
                    }
                    return isSameId;
                  });
                  cArr.push(...f);
                });
                cArr = uniqueElementsBy(
                  cArr,
                  (a, b) => a.id === b.id && a.uuid === b.uuid
                );
                let cRisk = [];
                this.judgeLimitdata(cArr, cRisk, spritesData);
                this.$store.commit("setCommercialRisk", cRisk);
                break;
            }
          }
          arr = uniqueElementsBy(
            arr,
            (a, b) => a.id === b.id && a.uuid === b.uuid
          );
          this.judgeLimitdata(arr, dataArray, spritesData);

          dataArray = dataArray.concat(EchartList);
          // dataArray = dataArray.concat(scenesSound);
          // const proVideos = (this.IsVipSprites.data || []).filter(v => v.id === 'uploadVideoNUM') || [];

          this.$store.commit("push_vipSprites", {
            data: [...dataArray],
            action: true,
          });
          this.$util.localStorage.set("checkMaterial", limitdata);
          dataArray = [];
          this.$bus.emit("app.checkedMaterialOnOpenPage");
          this.judgeToolVideo(true);
          return res.data;
        })
        .catch((err) => {
          this.$bus.emit("app.checkedMaterialOnOpenPage");
        });
    },
    judgeItemPayType(data, { willCheckCommercial = true } = {}) {
      if (this.willCheckMaterial === false) {
        return;
      }

      // if (this.isCoworker()) {
      //   return;
      // }
      // 判断素材收费种类
      let sprites = data || this.SelectSprites_Msg[0];
      if (sprites.groupId || sprites.FT) return;
      if (
        sprites.option &&
        "fileType" in sprites.option &&
        sprites.option.fileType &&
        this.allFormJson &&
        sprites.option.resourceId &&
        // sprites.opHelper.isSvip === false &&
        this.spritesMsg &&
        !sprites.opHelper.judgeItemLevel
      ) {
        if (this.LoadType === "blank" && this.isFirstAddSprite) {
          this.$bus.once("saveWorks.completed", () => {
            this.isFirstAddSprite = false;
            this.judgeItemPayType_(sprites, { willCheckCommercial });
          });
          this.$bus.emit("topnav.saveWorks", {});
        } else {
          this.judgeItemPayType_(sprites, { willCheckCommercial });
        }
      }

      let vipFont = sprites.type === "Text" && sprites.option.resourceId;
      let vipFonts =
        sprites.type === "RichText" &&
        sprites.option.resourceIds &&
        sprites.option.resourceIds.length;

      let vipSpritesCode = false;
      switch (sprites.type) {
        case "Chart":
          vipSpritesCode = true;
          break;
        case "Text":
          for (let t = 0; t < this.styleObject.length; t++) {
            let textAttrData = this.styleObject[t];
            if (
              textAttrData.isVip == 1 &&
              sprites.artType == textAttrData.val &&
              sprites.option &&
              !sprites.option.templateFree
            ) {
              if (!this.UserEquity.exclusive) {
                vipSpritesCode = true;
              }
              break;
            }
          }
          break;
      }

      if (
        (vipFont || vipFonts) &&
        this.allFormJson &&
        this.spritesMsg &&
        !vipSpritesCode
        // && !sprites.opHelper.judgeItemLevel
      ) {
        this.judgeItemPayType_(sprites, { willCheckCommercial });
      }

      // if (this.isPersonVideosEqual()) {
      //   vipSpritesCode = true;
      // }
      if (
        vipSpritesCode &&
        sprites.opHelper.isSvip === false &&
        !sprites.opHelper.judgeItemLevel
      ) {
        if (sprites.type == "Chart" && !this.UserEquity.Echart) {
          if (this.allFormJson) {
            this.$message({
              showClose: true,
              message:
                "您正在使用VIP功能或资源，若您需要导出视频，还请升级会员。",
              type: "error",
            });
          }
          sprites.opHelper.addSvip &&
            this.addSvipLabel(sprites, { payType: 6, fileType: "echart" });
        } else if (sprites.type == "Text") {
          sprites.opHelper.addSvip &&
            this.addSvipLabel(sprites, { payType: 4 });
          this.$message({
            showClose: true,
            message:
              "您正在使用VIP功能或资源，若您需要导出视频，还请升级会员。",
            type: "error",
          });
        }
        sprites.opHelper.isSvip = this.UserLevelName;
        if (!this.UserEquity.Echart || !this.UserEquity.exclusive) {
          this.$store.commit("push_vipSprites", {
            artword: sprites.artType,
            id: sprites.id,
            type: sprites.type,
            scenesId: sprites.scenesId,
            resourceId: sprites.option.resourceId,
            sceneIndex: this.TOOL.selectedScenes.index,
          });
        }
        this.vipMaterialsAndVipFunctions();
        sprites.opHelper.judgeItemLevel = true; // 判断是否被请求过
      } else if (sprites.opHelper && !sprites.opHelper.judgeItemLevel) {
        if ("showHideSvip" in sprites.opHelper) {
          sprites.opHelper.judgeItemLevel = true; // 判断是否被请求过
          sprites.opHelper.showHideSvip(false, false, true);
          this.$store.commit("del_vipSprites", { id: sprites.id });
        }
      }
      if (data && data.option && data.option.fileType == 26) {
        this.judgeToolVideo();
        // let limit = this.UserEquity.draftVideo;
        // if (this.FreeVideoIds.length < limit) {

        // }
      }
    },
    async judgeItemPayType_(data, { willCheckCommercial = true } = {}) {
      let sprites = data;
      let httpData = {
        uuid: sprites.id,
        id: sprites.option.resourceId,
        fileType: sprites.type === "Text" ? 15 : sprites.option.fileType,
      };
      switch (httpData.fileType) {
        case 30:
          httpData.type = sprites.option.type;
          break;
      }
      httpData = [httpData];

      const resourceIds = sprites.option.resourceIds;
      if (resourceIds && resourceIds.length) {
        httpData = resourceIds.map((v) => {
          return {
            uuid: sprites.id,
            id: v,
            fileType: 15,
          };
        });
      }

      willCheckCommercial && this.requestCheckCommercial();
      /*
      let commercialResp = await this.$http.post('/api/user/material/checkCommercial', {
        dataList: JSON.stringify(httpData.map(v => {
          return {
            uuid: v.uuid,
            id: v.id,
            resourceId: v.id,
            fileType: 15
          }
        })),
        draftId: window.location.hash.slice(2)
      });
      // let commercialRisk = commercialResp.data.data || {};
      if (commercialResp.data && commercialResp.data.code == 200) {
        let commercial = commercialResp.data.data;
        commercial = commercial.commercial;
        // if (commercial && commercial.length) {
        //   // commercial
        // } else {
        //   this.formatEditorData();
        // }
        this.formatEditorData();
        this.checkCommercialRiskList(commercial);
      }
      */

      // check material handler
      const handleResp = (res) => {
        // 请求素材数据
        let limitdata = res.data.data;
        let dataArray = "";
        let itemPayType = [];
        let toRemove = {
          flag: false,
          data: [],
        };
        if (!limitdata.removedMaterials) {
          limitdata.removedMaterials = [];
        }

        if (
          limitdata.toRemovedMaterials &&
          limitdata.toRemovedMaterials.length
        ) {
          toRemove.flag = true;
          toRemove.data = limitdata.toRemovedMaterials;
          this.handleToRemove(limitdata.toRemovedMaterials, sprites);
        }

        if (limitdata.removedMaterials && limitdata.removedMaterials.length) {
          itemPayType = "removedList";
          dataArray = limitdata.removedMaterials;
        } else if (limitdata.vipList && limitdata.vipList.length) {
          itemPayType = "vipList";
          dataArray = limitdata.vipList;
        } else if (limitdata.payList && limitdata.payList.length) {
          itemPayType = "payList";
          dataArray = limitdata.payList;
        } else if (limitdata.commercial) {
          itemPayType = "commercial";
          dataArray = limitdata.commercial;
        }
        let isTextLike = sprites.type === "RichText" || sprites.type === "Text";
        if (isTextLike) {
          // 删除角标
          sprites.opHelper.showHideSvip(false, false, true);
        }
        if (dataArray.length || isTextLike) {
          let data = dataArray[0];
          if (itemPayType == "vipList") {
            if (data.payType == null) {
              data.payType = 4;
            }
            // this.vipSpriteToast(data);
            switch (sprites.type) {
              case "bg":
              case "scenes":
              case "sound":
              case "groupSprites":
                break;
              default:
                this.addSvipLabel(sprites, data);
            }
          }

          if (itemPayType == "payList") {
            if (data.payType == null) {
              data.payType = 1;
            }
            this.addSvipLabel(sprites, data);
          }
          if (isTextLike && this.selectedVipFlag) {
          } else {
            this.vipSpriteToast(data, sprites);
          }
          this.selectedVipFlag = false;

          let pushVipMsg = {
            id: sprites.id,
            type: sprites.type,
            scenesId: sprites.scenesId,
            resourceId: sprites.option.resourceId,
            title: data && data.title,
            thumbnailUrl: data && data.thumbnailUrl,
            commercial: false,
          };
          if (itemPayType === "removedList") {
            pushVipMsg.removed = true;
            // pushVipMsg.resourceId = data && data.materialUid;
          }

          if (itemPayType === "commercial") {
            pushVipMsg.commercial = true;
          }
          pushVipMsg.payType = (data || {}).payType || 0;
          pushVipMsg.fileType = sprites.option.fileType;

          if (itemPayType == "payList") {
            pushVipMsg.price = data.price || data.originalPrice;
          }

          if (sprites.type === "Text") {
            pushVipMsg.fileType = 15;
          }

          if (
            limitdata.payList &&
            limitdata.payList.length &&
            sprites.type === "RichText"
          ) {
            let list = [...limitdata.payList, ...limitdata.vipList].map((v) => {
              return {
                id: sprites.id,
                type: sprites.type,
                scenesId: sprites.scenesId,
                resourceId: v.id,
                fileType: 15,
                payType: v.payType || 0,
                price: v.price || v.originalPrice,
                title: v.title,
                thumbnailUrl: v.thumbnailUrl,
                commercial: v.isCommerical,
              };
            });
            pushVipMsg = list;
          }
          let idFiltered = this.IsVipSprites.data.filter(
            (v) => v.id === sprites.id && v.commercial === sprites.commercial
          );
          idFiltered.forEach((item) => {
            this.$store.commit("del_vipSprites", item);
          });
          // let isCommercialRisk = limitdata.commercial && limitdata.commercial.length
          if (
            limitdata.payList.length ||
            limitdata.vipList.length ||
            limitdata.removedMaterials.length
          ) {
            this.$store.commit("push_vipSprites", {
              data: [].concat(pushVipMsg),
            });
          }
          if (pushVipMsg.commercial) {
            const cRisk = this.$store.getters["CommercialRisk"] || [];
            let arr = [].concat(pushVipMsg);
            arr = [...cRisk, ...arr];
            // let v = arr[0];
            // let specialVideo = cRisk.some(item => {
            //   return item.resourceId === v.resourceId;
            // });
            // specialVideo = specialVideo && v.id.indexOf('BG-') > -1;
            // if (specialVideo) {
            //   arr = cRisk;
            // }
            arr = uniqueElementsBy(
              arr,
              (a, b) => a.id === b.id && a.resourceId === b.resourceId
            );
            this.$store.commit("setCommercialRisk", arr);
          }
          if (sprites.opHelper) {
            sprites.opHelper.isSvip = this.UserLevelName;
          }
          this.vipMaterialsAndVipFunctions();
        }
        if (sprites.opHelper) {
          sprites.opHelper.judgeItemLevel = true; // 判断是否被请求过
        }

        //then end
      };

      // if (commercialResp.data && commercialResp.data.code == 200) {
      //   commercialResp.data.data.payList = [];
      //   commercialResp.data.data.vipList = [];
      //   handleResp(commercialResp);
      // }

      this.$http
        .post("/api/user/material/checkMaterial", {
          dataList: JSON.stringify(httpData),
          draftId: window.location.hash.slice(2),
        })
        .then(handleResp);
    },
    getNewSoundId(v) {
      let newSound = v.type || "newSound";
      return `${newSound}-${uuid.generate()}`;
    },
    async checkSoundsMaterial(list, soundType) {
      if (this.willCheckMaterial === false) {
        return;
      }

      let paramList = list.map((v) => {
        return {
          uuid: this.getNewSoundId({ type: soundType }),
          id: v.resourceId || v.id,
          fileType: v.fileType,
          type: "sound",
          timeSlot: v.timeSlot,
        };
      });
      paramList = paramList.filter((v) => v.id);
      let resp = await this.$http.post("/api/user/material/checkMaterial", {
        dataList: JSON.stringify(paramList),
        draftId: window.location.hash.slice(2),
      });
      let respData = resp.data.data || {};

      if (
        (respData.payList && respData.payList.length) ||
        (respData.vipList && respData.vipList.length)
      ) {
        const isToastInView = $(".vip-toast").length;
        isToastInView ||
          this.$message({
            showClose: true,
            message:
              "您正在使用VIP功能或资源，若您需要导出视频，还请升级会员。",
            type: "error",
            customClass: "vip-toast",
          });
      }
      let risks = this.$store.getters["IsVipSprites"];
      risks = risks.data || [];
      // risks = risks.filter(v => {
      //   return !paramList.some(u => u.id == v.resouceId)
      // });
      risks = risks.filter((v) => {
        let flag =
          v.id && v.id.length > 2 && v.id[0] == soundType && v.id[1] == "-";
        return !flag;
      });
      if (!list || !list.length) {
      }
      if (respData.removedMaterials) {
        let rList = respData.removedMaterials;
        rList = paramList.filter((v) => {
          return rList.some((u) => {
            let flag = u.materialUid == v.id;
            if (flag) {
              v.title = u.title;
              v.thumbnailUrl = u.thumbnailUrl;
              v.payType = u.payType;
            }
            return flag;
          });
        });
        rList.forEach((v) => {
          let item = {
            id: v.uuid,
            type: v.type,
            scenesId: "sound",
            resourceId: v.id,
            title: v.title,
            thumbnailUrl: v.thumbnailUrl,
            timeSlot: v.timeSlot,
            payType: v.payType,
            commercial: false,
            removed: true,
          };
          risks.push(item);
        });
      }
      if (respData.payList) {
        let rList = respData.payList;
        rList = paramList.filter((v) => {
          return rList.some((u) => {
            let flag = u.id == v.id;
            if (flag) {
              v.title = u.title;
              v.thumbnailUrl = u.thumbnailUrl;
              v.payType = u.payType;
            }
            return flag;
          });
        });
        rList.forEach((v) => {
          let isSome = respData.removedMaterials.some(
            (v) => v.materialUid == v.id
          );
          if (isSome) return;
          let item = {
            id: v.uuid,
            type: v.type,
            scenesId: "sound",
            resourceId: v.id,
            title: v.title,
            thumbnailUrl: v.thumbnailUrl,
            timeSlot: v.timeSlot,
            payType: v.payType,
            commercial: false,
          };
          risks.push(item);
        });
      }
      if (respData.vipList) {
        let rList = respData.vipList;
        rList = paramList.filter((v) => {
          return rList.some((u) => {
            let flag = u.id == v.id;
            if (flag) {
              v.title = u.title;
              v.thumbnailUrl = u.thumbnailUrl;
              v.payType = u.payType;
            }
            return flag;
          });
        });
        rList.forEach((v) => {
          let isSome = respData.removedMaterials.some(
            (v) => v.materialUid == v.id
          );
          if (isSome) return;
          let item = {
            id: v.uuid,
            type: v.type,
            scenesId: "sound",
            resourceId: v.id,
            title: v.title,
            thumbnailUrl: v.thumbnailUrl,
            timeSlot: v.timeSlot,
            payType: v.payType,
            commercial: false,
          };
          risks.push(item);
        });
      }

      this.$store.commit("push_vipSprites", {
        data: [...risks],
        action: true,
      });
    },
    checkSoundSwap(list) {
      let isSwap = list.some((v) => {
        let slot = v.timeSlot || [];
        let f = this.IsVipSprites.data.some((u) => {
          let slotMatched =
            u.timeSlot &&
            slot[0] === u.timeSlot[0] &&
            slot[1] === u.timeSlot[1];
          return v.id === u.resourceId && slotMatched;
        });
        return !f;
      });
      return isSwap;
    },
    isCoworker() {
      // return this.cooperationDraftOwnerId && this.cooperationDraftOwnerId !== this.UserMsg.id;
      return false;
    },
    async upDataUserMsg() {
      const respIsOld = await this.$http.get('/api/user/vip/info/getVip630');
      if (respIsOld.data.code === 200) {
        this.$store.commit('setIsOldUser', !!respIsOld.data.data.isOld)
      }
      // 更新用户数据
      const vm = this;
      this.$http.get("/api/session").then(async (res) => {
        let { data: resData } = res.data;
        const teamInfoRes = await this.$http.get(
          "/api/user/account/cooperation/teamInfo"
        );
        const teamInfo = teamInfoRes.data.data || {};
        // const lackVisualAssets = !teamInfo.materialEndTime;
        const outOfDate = (teamInfo.materialEndTime || 0) * 1000 < Date.now();
        let teamOwnerLevelType = resData.levelType;
        if (
          teamInfo.user &&
          teamInfo.user.ul &&
          teamInfo.user.ul.levelType > -1
        ) {
          teamOwnerLevelType = teamInfo.user.ul.levelType;
        }
        const lackVisualAssets =
          (teamOwnerLevelType === 0 && outOfDate)
          // || (resData.tmpLevelType === 0 && outOfDate)
        resData.lackVisualAssets = lackVisualAssets;

        this.$store.commit("save_UserId", resData.id);

        // 临时体验会员
        // if (resData.tmpLevelType != null && resData.tmpLevelType > 1) {
        //   // if (resData.tmpLevelName && (/solo/i.test(resData.tmpLevelName) || /个人VIP/i.test(resData.tmpLevelName))) {
        //   //   resData.levelType = 0;
        //   //   // 38 个人vip季度
        //   //   resData.level = 38;
        //   // } else {
        //   //   resData.levelType = 2;
        //   // }
        //   resData.level = resData.tmpLevel;
        //   resData.levelType = resData.tmpLevelType;
        // }

        // if (resData.tmpLevelType != null && resData.tmpLevelType === 0) {
        //   resData.levelType = 0;
        //   // resData.level = 25;
        //   resData.level = resData.tmpLevel;
        // }

        if (!resData.isSonAccount) {
          this.$http
            .get("/api/user/account/family/sonList")
            .then((accountData) => {
              accountData = accountData.data.data;
              if (!accountData.length) {
                delete resData.sonAccount;
              }
              this.$store.commit("toggle_UserMsg", resData);
            })
            .then((accountData) => {
              // 总时长限制
              if (this.UserEquity && this.UserEquity.time && this.TOOL) {
                this.TOOL.limitTime = this.UserEquity.time;
              }
            });
        } else {
          this.$store.commit("toggle_UserMsg", resData);
          if (this.UserEquity && this.UserEquity.time && this.TOOL) {
            this.TOOL.limitTime = this.UserEquity.time;
          }
        }

        this.$http.get("/api/user/account/cooperation/userInfo").then((res) => {
          if (res.data.code === 200) {
            //console.log(res.data.data)
            this.$store.commit("save_userTeamInfo", res.data.data);
          }
        });
        this.$http.get("/api/user/account/cooperation/teamInfo").then((res) => {
          if (res.data.code === 200) {
            //console.log(res.data.data)
            this.$store.commit("save_teamInfo", res.data.data);
          }
        });
        // 品牌颜色的问题
        this.$http.get("/api/user/brand/color").then((res) => {
          if (res.data.code === 200) {
            this.$store.commit("save_brandColor", res.data.data);
          } else {
            this.$store.commit("save_brandColor", null);
          }
        });

        this.$bus.emit("upDataUserMsg_vue_done");
      });
    },
    vipMaterialsAndVipFunctions() {
      // 添加选择
      for (let i = 0; i < this.TOOL.sprites.length; i++) {
        if (this.TOOL.sprites[i].id === this.TOOL.selectedScenes.id) {
          let vipMaterials = [],
            vipFunctions = [];
          for (let j = 0; j < this.IsVipSprites.data.length; j++) {
            if (
              this.TOOL.selectedScenes.id === this.IsVipSprites.data[j].scenesId
            ) {
              switch (this.IsVipSprites.data[j].type) {
                case "Chart":
                  if (!vipFunctions.length) {
                    vipFunctions.push({
                      resourceId: "00000000-0000-0000-0000-000000000000",
                      type: "ChartEdit",
                      vipLevel: 2,
                    });
                  }
                  break;
                default:
                  vipMaterials.push({
                    resourceId: this.IsVipSprites.data[j].resourceId,
                    vipLevel: 1,
                  });
              }
            }
          }
          this.TOOL.sprites[i].vipMaterials = vipMaterials;
          this.TOOL.sprites[i].vipFunctions = vipFunctions;
          break;
        }
      }
    },
    judgeSoundBgIsVip(data) {
      let setData = true;
      for (let i = 0; i < this.IsVipSprites.data.length; i++) {
        let sprite = this.IsVipSprites.data[i];
        if (data == sprite.id) {
          setData = false;
        }
      }
      return setData;
    },
    handlePersonVideo(data, o = 1) {
      const vm = this;
      let ss = vm.TOOL.sprites.reduce((memo, v, i) => {
        return memo.concat(v.sprites);
      }, []);
      let tt = this.TOOL.sprites.concat(ss);

      let fileType;
      if (data.type) {
        fileType = data.option.fileType;
      } else {
        fileType = data.background.data.fileType;
      }

      if (fileType === 26 || fileType === 27) {
        this.$store.commit("countPersonVideo", this.PersonVideoNumber + o);
      }
    },
    addSvipLabel(sprite, data) {
      if (this.isCoworker()) {
        return;
      }
      let label = "",
        name = "";
      // 4 — 会员专属 1 — 单独付费 0 — 免费
      // 付款类型 0免费  1付费-会员免费  2付费(优惠价) 3付费(折扣) 4企业专属 5:来画币 6.付费-企业会员免费
      // 类型0 免费 什么都不显示 （所有用户视角）
      // 类型1和6 就显示VIP和企业VIP角标 （所有用户视角）
      // 类型2、3  （企业至尊版视角什么都不显示，其余用户都显示价格）

      // 字体、人物、道具、音乐 的付费类型包括：0，1，2，3，6
      // 模板 的付费类型包括：0，1，6
      switch (data.payType) {
        case 6:
          label = " ";
          name = "handle-svip";
          break;
        case 4:
          if (!this.UserEquity.exclusive) {
            label = " " || "VIP";
            name = 'handle-enterpriseS';
            if (this.IsOldUser) {
              name = "handle-solo";
            }
          }
          if (
            data.fileType &&
            this.UserEquity.soloLimit &&
            typeof data.fileType !== "number" &&
            this.UserEquity.soloLimit.indexOf(data.fileType) >= 0
          ) {
            label = " " || "VIP";
            name = "handle-svip";
          }
          break;
        case 3:
        case 2:
          label = "¥ " + data.price;
          name = "handle-price";
          break;
        case 1:
          label = "¥ " + data.price;
          name = "handle-price";
          break;
      }
      if (
        sprite.opHelper &&
        (this.UserMsg.payForMaterial != 1 ||
          (sprite.type === "Text" && this.UserMsg.payForFont !== 1) ||
          (sprite.type === "RichText" && this.UserMsg.payForFont !== 1)) &&
        sprite.opHelper.addSvip &&
        label &&
        name
      ) {
        sprite.opHelper.addSvip(label, name);
      }
    },
    judgeLimitdata(data, pushData, origin = []) {
      for (let t = 0; t < data.length; t++) {
        let sprites = null;
        let itemData = data[t];
        let pushItem = {};
        let extra = {
          resourceId: itemData.id,
          sceneIndex: itemData.sceneIndex,
          payType: itemData.payType,
          title: itemData.title,
          thumbnailUrl: itemData.thumbnailUrl,
          commercial: itemData.commercial,
          removed: itemData.removed,
          toRemove: itemData.toRemove,
        };

        switch (+itemData.fileType) {
          case 1:
          case 2:
          case 25:
            sprites = this.TOOL.getScenesIdData(itemData.uuid) || {};
            pushItem = {
              id: "BG-" + sprites.id,
              type: "bg",
              scenesId: sprites.scenesId,
              resourceId: itemData.id,
            };
            break;
          case 24:
            pushItem = {
              id: itemData.scenesId,
              type: "scenes",
              scenesId: itemData.scenesId,
              resourceId: itemData.id,
            };
            break;
          case 14:
            pushItem = {
              id: itemData.uuid,
              type: "sound",
              scenesId: "sound",
              resourceId: itemData.id,
              timeSlot: itemData.timeSlot,
            };
            break;
          case 30:
            let sprites = itemData;
            pushItem = {
              id: sprites.uuid,
              type: "groupSprites",
              scenesId: sprites.scenesId,
              resourceId: sprites.id,
            };
            break;
          default:
            sprites = this.TOOL.getSpriteIdData(itemData.uuid) || {};

            pushItem = {
              id: sprites.id,
              type: sprites.type,
              scenesId: sprites.scenesId,
              resourceId: itemData.id,
            };
            if ("price" in itemData) {
              if (itemData.payType == null) {
                itemData.payType = 1;
              }
              if (sprites.opHelper) {
                this.addSvipLabel(sprites, itemData);
                sprites.opHelper.showHideSvip(false);
                sprites.opHelper.isSvip = this.UserLevelName;
              }
            } else if (!this.UserEquity.exclusive) {
              if (itemData.payType == null) {
                itemData.payType = 4;
              }
              if (sprites.opHelper) {
                this.addSvipLabel(sprites, itemData);
                sprites.opHelper.showHideSvip(false);
                sprites.opHelper.isSvip = this.UserLevelName;
              }
            }

            break;
        }
        pushItem.fileType = itemData.fileType;
        if ("price" in itemData) {
          pushItem.price = itemData.price;
          // pushData.push(pushItem);
        }
        pushItem = {
          ...extra,
          ...pushItem,
        };

        pushData.push(pushItem);
      }
    },
    videoExistPro: async function (sceneData, limit) {
      if (!this.willCheckMaterial) {
        return;
      }
      // 判断含有多少自己的video素材
      let scene = sceneData || this.TOOL.selectedScenes;
      let sprites = scene.sprites || [];
      let bgType = scene.background.data;
      let videoBgExist = 0;
      let scenes = [];
      let vSprites = [];
      let freeVideoIds = [];
      bgType.fileType = bgType.fileType - 0;
      let vui;
      if (this.userIdMap[bgType.resourceId]) {
        vui = this.userIdMap[bgType.resourceId];
      } else if (bgType.type == "Video" && bgType.resourceId) {
        try {
          let resp = await this.$http.get(
            `/api/user/video?id=${bgType.resourceId}&sOfPage=24&fPage=24&pIndex=1&fileType=26`
          );
          vui = (resp.data.data || {}).userId || "none";
          this.userIdMap[bgType.resourceId] = vui;
        } catch (err) {
          console.log(" -> err", err);
        }
      }
      if (
        bgType.type === "Video" &&
        bgType.fileType == 26 /* && this.isUserId(bgType.userId) */ &&
        bgType.userId &&
        bgType.userId == vui
      ) {
        videoBgExist = 1;
        if (freeVideoIds.length < limit) {
          freeVideoIds.push(scene.id);
        }
        scenes.push({ id: scene.id, index: scene.index });
      }
      let videoSpriteExist =
        sprites.filter(
          (s) => s.type === "Video" || (s.option || {}).fileType === 26
        ) || [];

      for (let i = 0; i < videoSpriteExist.length; i++) {
        let jsonData = videoSpriteExist[i].toJson
          ? videoSpriteExist[i].toJson()
          : {
              resourceId: videoSpriteExist[i].option.resourceId,
              type: "Video",
              fileType: 26,
            };
        let vui;
        if (this.userIdMap[jsonData.resourceId]) {
          vui = this.userIdMap[jsonData.resourceId];
        } else if (jsonData.resourceId) {
          try {
            let resp = await this.$http.get(
              `/api/user/video?id=${jsonData.resourceId}&sOfPage=24&fPage=24&pIndex=1&fileType=26`
            );
            vui = (resp.data.data || {}).userId || "none";
            this.userIdMap[jsonData.resourceId] = vui;
          } catch (err) {}
        }
        if (!videoSpriteExist[i].toJson) {
          jsonData.userId = vui;
        }
        if (
          jsonData.type === "Video" &&
          jsonData.fileType == 26 /* && this.isUserId(jsonData.userId) */ &&
          jsonData.userId &&
          jsonData.userId == vui
        ) {
          videoBgExist += 1;
          if (freeVideoIds.length < limit) {
            freeVideoIds.push(videoSpriteExist[i].id);
          }
          vSprites.push({ id: videoSpriteExist[i].id, index: scene.index });
        }
      }

      // let ret = videoBgExist;
      let ret = {
        sprites: vSprites,
        scenes,
        num: videoBgExist,
        free: freeVideoIds,
      };
      return ret;
    },
    isUserId(id) {
      let storedId = this.UserMsg.id;
      let nid = +id;
      if (nid && typeof nid === "number") {
        return storedId === id;
      }

      return true;
    },
    judgeToolVideo() {
      // 取消基础版、个人版个人视频限制
    },
    judgeToolVideoX(noMsg) {
      if (this.isCoworker()) {
        return;
      }
      // 判断含有多少自己的video素材
      let timeoutid = setTimeout(
        async function () {
          let videonum = 0;
          let obj;
          let vScenes = [];
          let vSprites = [];
          let vFree = [];
          for (let i = 0; i < this.TOOL.sprites.length; i++) {
            let sprite = this.TOOL.sprites[i];
            obj = (await this.videoExistPro(
              sprite,
              this.UserEquity.draftVideo
            )) || {
              scenes: [],
              sprites: [],
              free: [],
              num: 0,
            };
            vScenes = [...vScenes, ...obj.scenes];
            vSprites = [...vSprites, ...obj.sprites];
            vFree = [...vFree, ...obj.free];
            videonum += obj.num;
          }
          if (this.UserEquity.draftVideo < videonum) {
            this.$store.commit(
              "save_freeVideoIds",
              vFree.slice(0, this.UserEquity.draftVideo)
            );
            this.$store.commit("push_vipSprites", {
              id: "uploadVideoNUM",
              type: "uploadVideoNUM",
              scenesId: "uploadVideoNUM",
              videoNum: videonum,
              scenes: vScenes,
              sprites: vSprites,
              firstId: obj.firstId,
            });

            if (this.allFormJson && !noMsg) {
              if (videonum > 3) {
                this.$message({
                  showClose: true,
                  message:
                    "您本地上传的视频资源大于3个，开通企业会员可无限使用。",
                  type: "error",
                });
              } else {
                this.$message({
                  showClose: true,
                  message:
                    "您本地上传的视频资源大于1个，升级个人VIP可扩充到三个。",
                  type: "error",
                });
              }
            }
          } else {
            this.$store.commit("del_vipSprites", { id: "uploadVideoNUM" });
            this.$store.commit("delCommercialRisk", { id: vSprites.id });
          }
          clearTimeout(timeoutid);
        }.bind(this),
        200
      );
    },
    vipSpriteToast(data, sprite) {
      if (this.isCoworker() || $(".vip-toast").length || !data) {
        return;
      }
      // vip toast提示
      if (data.payType) {
        data.payType = data.payType - 0;

        switch (data.payType) {
          case 1:
          case 2:
          case 3:
            let isFontLike =
              sprite && (sprite.type === "Text" || sprite.type === "RichText");
            (this.UserMsg.payForMaterial != 1 ||
              (isFontLike && this.UserMsg.payForFont !== 1)) &&
              this.$message({
                showClose: true,
                message:
                  "您添加了付费资源，若您需要导出视频，请购买后再尝试导出！",
                type: "error",
                customClass: "vip-toast",
              });
            break;
          case 4:
          case 6:
            this.$message({
              showClose: true,
              message:
                "您正在使用VIP功能或资源，若您需要导出视频，还请升级会员。",
              type: "error",
              customClass: "vip-toast",
            });
            break;
        }
      }
    },
    versionToolFS() {
      var strt = this.UserMsg.versionTOOL + "",
        version = "";
      for (let index = 0, jk = strt.length; index < jk; index++) {
        if (index !== strt.length - 1) {
          version = version + strt[index] + ".";
        } else {
          version = version + strt[index];
        }
      }
      return version;
    },
    getCheckFont(toolFont = []) {
      let downFonts = [];
      let downFont = null;
      let getDelayTime = function (time) {
        if (!time) return;
        let now = new Date(time * 1000);
        let fu = now.setFullYear(now.getFullYear() + 1);
        fu = new Date(fu).toISOString();
        fu = fu.split(/-|T/);
        fu.length = 3;
        return fu.join(".");
      };
      toolFont.unshift(this.downFonts[1].value);
      toolFont.unshift(this.downFonts[0].value);
      this.$http
        .get("/api/user/brand/font")
        .then((res) => {
          if (res.status === 200 && res.data.code === 200 && res.data.data) {
            let data = res.data.data;
            let textOption = {};
            for (let k in data) {
              if (k === "title" || k === "subtitle" || k === "content") {
                let title = data[k];
                this.loadFonts(title.font.url);
                toolFont.push(title.font.url);
                textOption[k] = {
                  fontId: title.font.id,
                  font: {
                    fontFamilyUrl: title.font.url,
                    fontSize: title.size || 80,
                    color: title.color || "#303233",
                    fontWeight: title.blod === 0 ? "normal" : "bold",
                    fontStyle: title.italic === 0 ? "normal" : "italic",
                    textDecoration:
                      title.underline === 0 ? "none" : "underline",
                  },
                };
              }
              if (k === "fontList") {
                let brandList = [];
                data[k].forEach((v) => {
                  brandList.push({
                    id: v.id,
                    value: v.url,
                    label: v.title,
                    fontUrl: v.fontUrl,
                  });
                });
                this.$store.commit("toggle_brandList", brandList);
              }
            }
            this.$store.commit("toggle_textOption", textOption);
          }

          toolFont = [...new Set(toolFont)];

          this.$http
            .get(
              "/api/common/material?style=1&type=6&sOfPage=500&fPage=500&pIndex=1"
            )
            .then((res) => {
              if (res.data.data) {
                toolFont.forEach((item) => {
                  for (let i in res.data.data) {
                    downFont = res.data.data[i];
                    if (item === downFont.url) {
                      downFonts.push({
                        id: downFont.id,
                        value: downFont.url,
                        fontUrl: downFont.fontUrl,
                        label: downFont.title,
                        payType: downFont.payType,
                        isPay: downFont.tt ? true : false,
                        price: downFont.price,
                        delayTime:
                          downFont.tt && getDelayTime(downFont.tt.createTime),
                        status: 2,
                      });
                      break;
                    }
                  }
                });
                this.$store.commit("toggle_downFonts", downFonts);
              }
            });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    isUUID(val = "") {
      return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
        val
      );
    },
    handleDubbingText(val) {
      this.dubbingArr.forEach((v, i) => {
        let f = val.find((u) => u.url === v.url);
        if (f) {
          this.$store.commit("addSoundtrack/updateDubbing", {
            index: i,
            dubbing: {
              text: f.text,
            },
          });
        }
      });
      this.$bus.emit("replace_current_dubing");
    },
    async ifShowUserTask () {
      if (this.$route.userTask) {
        const resp = await this.$http.get('/api/user/info/applyInfo?type=27');
        const data = resp.data.data;
        // if (!data || data && data.state === 0) {
        if (!data) {
          this.$store.commit('userTask/setViewType', 'task');
        }
      }
    }
  },
  components: {
    TopNav,
    Scenes,
    Tool,
    EyedropperBox,
    RightNav,
    // MaterialPane,
    MaterialArea,
    SettingPanel,
    Popups,
    Sound,
    Keyboard,
    Modal,
    Undo,
    Upload,
    EModals,
    EModals2,
    Draw,
    Guidance,
    Tip,
    PopupsZ,
    CropLayer,
    CropSvgLayer,
    CutFrame,
    NewVersion,
    TakePoints,
    TransparentMask,
    PayPanel,
    freePathEdit,
    WordCloud,
    TemplateMaterialLibrary,
    // FloatingMenu,
    AnimCourse,
    SubtitleMessageDialog,
    UserTask,
    UserTaskQuitting,
    UserTaskFinishing,
    presentationLayer,
    invitationNotice
  },
};
</script>

<style lang="scss">
.el-loading-spinner .el-loading-text {
  color: #5778fb;
  font-size: 13px;
}
.el-laihua-loading {
  position: absolute;
  top: -7px;
  left: 20%;
  width: 47px;
  height: 29px;

  .el-loading-text {
    margin-top: 20px;
  }

  &:before {
    display: none;
  }
}

@import "./src/style/vueBar";
@import "./src/style/icons";
@import "./src/style/button";
@import "./src/style/_pluginModalCustom";

#app {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  overflow: hidden;
  width: 100%;
  height: 100%;
  .mask-blur {
    width: auto !important;
    height: auto !important;
  }
}
.global-app {
  &:focus {
    border: 0;
    outline: none;
    cursor: default;
    caret-color: transparent;
  }
}

.debug {
  outline: 1px red solid;
}
.itemAudio,
.item {
  .collection_sprite_icon {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 100;
    width: 22px;
    height: 22px;
    background: url("../static/svg/collection-icon.svg") no-repeat center;
    cursor: pointer;
    opacity: 0;

    &:hover {
      filter: brightness(1.4);
    }
  }
  .collection_sprite_icon_active {
    background: url("../static/svg/collection-icon-active.svg") no-repeat center;
  }
  &:hover {
    .collection_sprite_icon {
      opacity: 1;
    }
  }
}

.__empty-msg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  & > .icon {
    width: 32px;
    height: 32px;
    margin: auto;
    background-image: url(../static/svg/right-nav-new/empty-canvas.svg);
    background-repeat: no-repeat;
  }
  & > .msg {
    margin-top: 16px;
    margin-bottom: 8px;
    color: #474261;
    font-size: 14px;
    font-weight: bold;
  }
  & > .msg-small {
    color: #474261;
    font-size: 14px;
    line-height: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue